import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PHONE_NUMBER_PATTERN } from './validation-patterns';

/**
 * Validator for US phone numbers.
 * Accepts formats: (123) 456-7890, 123-456-7890, 123.456.7890, 1234567890
 * Also allows empty values for optional phone fields.
 * 
 * @returns ValidatorFn that validates phone number format
 * 
 * @example
 * ```typescript
 * this.form = this.fb.group({
 *   phone: ['', phoneValidator()]
 * });
 * ```
 */
export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // Allow empty values
    }

    const isValid = PHONE_NUMBER_PATTERN.test(control.value);

    return isValid ? null : { invalidPhone: { value: control.value } };
  };
}
